import { HttpErrorResponse } from '@angular/common/http';

export interface ApiErrorDetails {
  status: number | null;
  code: string | null;
  message: string | null;
  details: string | null;
  raw: unknown;
}

export function extractApiError(err: unknown): ApiErrorDetails {
  if (!(err instanceof HttpErrorResponse)) {
    return { status: null, code: null, message: null, details: null, raw: err };
  }

  const payload = err.error;
  const firstError = Array.isArray(payload) && payload.length > 0
    ? payload[0]
    : payload;

  if (firstError && typeof firstError === 'object') {
    const errorObject = firstError as { code?: string; message?: string; details?: string };
    return {
      status: err.status,
      code: errorObject.code ?? null,
      message: errorObject.message ?? null,
      details: errorObject.details ?? null,
      raw: payload,
    };
  }

  return {
    status: err.status,
    code: null,
    message: typeof payload === 'string' ? payload : err.statusText,
    details: null,
    raw: payload,
  };
}
